import React from 'react';
import PropTypes from 'prop-types';

import { FormsCollection } from '../../../../../components';
import './style.sass';

const FieldItem = ({
  error,
  value,
  name,
  touched,
  onBlur,
  onChange,
  onDelete,
  t,
}) => (
  <div className="invite-members__row">
    <FormsCollection.Input
      name={name}
      id="invite-members__email"
      error={error}
      value={value}
      type="email"
      touched={touched}
      className="col-lg-11"
      placeholder="example@example.com"
      onChange={onChange}
      onBlur={onBlur}
    />
    {
      onDelete && (
        <div className="col-lg-1">
          <button
            type="button"
            className="invite-members__button-remove"
            title={t('Delete')}
            onClick={onDelete}
          >
            <span className="icon-trash" />
          </button>
        </div>
      )
    }
  </div>
);

FieldItem.propTypes = {
  name: PropTypes.string.isRequired,
  error: PropTypes.string,
  value: PropTypes.string,
  touched: PropTypes.bool,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.bool,
  ]),
  t: PropTypes.func.isRequired,
};

FieldItem.defaultProps = {
  onDelete: false,
  error: '',
  touched: false,
  value: '',
};


export default FieldItem;
